import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-trip-action-dropdown',
  templateUrl: './trip-action-dropdown.component.html',
  styleUrls: ['./trip-action-dropdown.component.css']
})
export class TripActionDropdownComponent {
  @Input() trip:any;
  @Output() edit = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() notes = new EventEmitter<any>();
  @Output() cancelPendingTrip = new EventEmitter<any>();
  @Output() reofferPendingTrip = new EventEmitter<any>();
  @Output() raiseTicket = new EventEmitter<any>();
}
